<template lang="html">
  <div class="sample">
    <slot></slot>
  </div>
</template>

<script>
export default {}
</script>

<style lang="scss">
.sample {
  display: flex;
  width: 100%;
}
</style>
